import {Link} from 'react-router-dom'
import {useContext, useState} from 'react'
import {ProductWiseReportContext} from '../../context'
import ProfitTrendModal from '../modals/ProfitTrendModal'

const ProductWiseReportRow = ({row}: any) => {
  const [showProfitTrendModal, setShowProfitTrendModal] = useState(false)
  const {
    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useContext(ProductWiseReportContext)
  return (
    <>
      <tr>
        <td>
          <div className='d-flex align-items-center py-2'>
            <div className='symbol symbol-40px me-3 border'>
              <img src={row.thumbnail_url} alt='productimage' />
            </div>
            <div className='d-flex flex-column'>
              <span>{row.productName}</span>
            </div>
          </div>
        </td>
        <td>{row.sku}</td>
        <td>{row.classifications?.map((item: any) => item).join(', ')}</td>
        <td>{row.suppliers?.map((item: any) => item).join(', ')}</td>
        {/* <td>{row.averageCostPerPiece}</td>
        <td>{row.averageSellingPricePerPiece}</td> */}
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&product_id=${row.productId}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>{row.totalCost}</td>
        <td>{row.totalSale}</td>
        <td>{row.totalProfit}</td>
        <td>
          <span
            onClick={() => setShowProfitTrendModal(true)}
            className='text-hover-primary cursor-pointer text-decoration-underline'
            style={{cursor: 'pointer'}}
          >
            {row.totalProfitPercentage}
          </span>
        </td>
        <td className='text-end'>{row.contributedProfitPercentage}</td>
      </tr>

      {showProfitTrendModal && (
        <ProfitTrendModal
          onClose={() => setShowProfitTrendModal(false)}
          entityId={row.productId}
          entityName={row.productName}
          onProfitTrendIdChange={onProfitTrendIdChange}
          isProfitTrendDataLoading={isProfitTrendDataLoading}
          profitTrendChartData={profitTrendChartData}
          kpiData={profitTrendKpiData}
          weeklyBreakdownData={profitTrendWeeklyBreakdownData}
        />
      )}
    </>
  )
}

export default ProductWiseReportRow
